import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
  retrieve_warehouse_inventory_summary_data: {
    status: app_consts.IDLE,
    message: "",
    data: null,
  },
};

const retrieve_warehouse_inventory_summary_data_Slice = createSlice({
  name: "retrieve_warehouse_inventory_summary_data",
  initialState,
  reducers: {
    loading_retrieve_warehouse_inventory_summary_data: (state) => {
      state.retrieve_warehouse_inventory_summary_data.status = app_consts.LOADING;
      state.retrieve_warehouse_inventory_summary_data.message = "";
      state.retrieve_warehouse_inventory_summary_data.data = null;
    },

    success_retrieve_warehouse_inventory_summary_data: (state, action) => {
      state.retrieve_warehouse_inventory_summary_data.status = app_consts.SUCCESS;
      state.retrieve_warehouse_inventory_summary_data.message = action?.payload?.message || "";
      state.retrieve_warehouse_inventory_summary_data.data =
        action?.payload?.data ?? action?.payload ?? null;
    },

    fail_retrieve_warehouse_inventory_summary_data: (state, action) => {
      state.retrieve_warehouse_inventory_summary_data.status = app_consts.FAIL;
      state.retrieve_warehouse_inventory_summary_data.message =
        action?.payload?.message ||
        action?.payload ||
        "Failed to retrieve stock levels summary data.";
      state.retrieve_warehouse_inventory_summary_data.data = null;
    },

    reset_retrieve_warehouse_inventory_summary_data: (state) => {
      state.retrieve_warehouse_inventory_summary_data.status = app_consts.IDLE;
      state.retrieve_warehouse_inventory_summary_data.message = "";
      state.retrieve_warehouse_inventory_summary_data.data = null;
    },
  },
});

export const {
  loading_retrieve_warehouse_inventory_summary_data,
  success_retrieve_warehouse_inventory_summary_data,
  fail_retrieve_warehouse_inventory_summary_data,
  reset_retrieve_warehouse_inventory_summary_data,
} = retrieve_warehouse_inventory_summary_data_Slice.actions;

export default retrieve_warehouse_inventory_summary_data_Slice.reducer; 
